<template>
    <div>
        <Dropdown trigger="click" @on-click="hclick" @click.native="aclick">
            <a href="javascript:void(0)" style="display: block;width: 50px;text-align: right;">
                <Icon type="md-more" size="20" style="vertical-align: middle;"></Icon>
            </a>
            <DropdownMenu slot="list">
                <DropdownItem name='1' v-show="isShowAdd">新建子文件夹</DropdownItem>
                <DropdownItem name='2' v-show="isShowEdit">重命名文件夹</DropdownItem>
                <DropdownItem name='3' v-show="isShowDel">删除文件夹</DropdownItem>
                <DropdownItem name='4' v-show="isShowSelecter">移动文件夹</DropdownItem>
            </DropdownMenu>
        </Dropdown>
        <Modal v-model="renameModal" width="450" :mask-closable="false" @on-cancel="cancelRenameModal">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>重命名文件夹</span>
            </p>
            <div style="text-align:center;">
                <div style="text-align: left;line-height: 40px;height: 40px;display: bolck;">原名称：<span style="color:#808695;">{{node.node.title}}</span></div>
                <Input v-model="value" placeholder="请输入新文件夹名称" maxlength="20" />
            </div>
            <div slot="footer" :style="{display:isShowModalFooter?'block':'none'}">
                <Button type="text" size="large" @click="cancelRenameModal">取消</Button>
                <Button type="primary" size="large" @click="editNodeData">提交</Button>
            </div>
        </Modal>
        <Modal v-model="newFolderModal" width="450" :mask-closable="false" @on-cancel="cancelNewFolderModal">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>新建文件夹</span>
            </p>
            <div style="text-align:center;">
                <div style="text-align: left;line-height: 40px;height: 40px;display: bolck;">文件夹名称：
                    <!-- <span style="color:#808695;">{{node.node.title}}</span> -->
                </div>
                <Input v-model="newfoldervalue" placeholder="请输入文件夹名称" maxlength="20"/>
            </div>
            <div slot="footer" :style="{display:isShowModalFooter?'block':'none'}">
                <Button type="text" size="large" @click="cancelNewFolderModal">取消</Button>
                <Button type="primary" size="large" @click="newFolder">提交</Button>
            </div>
        </Modal>
        <Modal v-model="treeSelectModal" width="450" :mask-closable="false" @on-cancel="cancelTreeSelectModal">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>正在移动文件夹</span>
            </p>
            <div>
                <div style="text-align: left;line-height: 40px;height: 40px;display: bolck;">请选择目标文件夹：
                    <!-- <span style="color:#808695;">{{node.node.title}}</span> -->
                </div>
                <!--  <TreeSelecter ref="treeSelecter" @destination-folder="setDestinFolder" :raw="rawData" /> -->
                <TreeSelecter ref="treeSelecter" @destination-folder="setDestinFolder" />
            </div>
            <div slot="footer" :style="{display:isShowModalFooter?'block':'none'}">
                <Button type="text" size="large" @click="cancelTreeSelectModal">取消</Button>
                <Button type="primary" size="large" @click="moveFolder">提交</Button>
            </div>
        </Modal>
    </div>
</template>
<script type="text/javascript">
import treeselecter from './droptree_child.vue'
export default {
    name: 'popmenu',
    inject: ["addChild", "removeNode", "editNode", "moveNode", "totalFiles"],
    props: {
        root: Array,
        node: Object,
        nodeData: Object,
        rawData: Array,
        isShowAdd: {
            type: Boolean,
            default: true,
        },
        isShowDel: {
            type: Boolean,
            default: true,
        },
        isShowEdit: {
            type: Boolean,
            default: true,
        },
        isShowSelecter: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        'TreeSelecter': treeselecter,
    },
    data() {
        return {
            destinationFolder: null,
            treeSelectModal: false,
            renameModal: false,
            newFolderModal: false,
            isShowModalFooter: true,
            value: '',
            newfoldervalue: '',
        }
    },
    methods: {
        setDestinFolder(value) {
            this.destinationFolder = value
            // console.log('setDestinFolder')
            // console.log(value)
        },
        moveFolder() {
            
            this.moveNode(this.root, this.node, this.nodeData, this.destinationFolder)
            this.cancelTreeSelectModal()
        },
        newFolder() {
            //判断是否为空字符
            if (!this.newfoldervalue) {
                this.$Message.warning('请填写文件夹名。')
                return
            }
            if (this.newfoldervalue==='全部文件归档') {
                this.$Message.warning('此文件名已被占用。')
                return
            }
            
            let child = {
                value: this.root.length,
                title: this.newfoldervalue,
                expand: true,
                _select: false,
            }
            this.addChild(this.nodeData, child)
            this.newFolderModal = false
        },
        editNodeData() {
            console.log('editNodeData=====>')
            //console.log(node)
            //this.nodeData.title = this.value
            this.editNode(this.nodeData,this.value)
            this.renameModal = false
        },
        cancelRenameModal() {
            this.renameModal = false
        },
        cancelNewFolderModal() {
            this.newFolderModal = false
        },
        cancelTreeSelectModal() {
            this.treeSelectModal = false
        },
        hclick(name) {
            console.log(name)
            console.log(this.node)
            switch (name) {
                case '1':
                    console.log(this.nodeData)
                    console.log('new')
                    this.newFolderModal = true
                    //this.addChild(this.nodeData)
                    break;
                case '2':
                    console.log('rename')
                    this.renameModal = true
                    break;
                case '3':
                    console.log('del')
                    if (this.nodeData.children && this.nodeData.children.length > 0) {
                        this.showDialog2('提示', this.node.node.title)
                    } else {
                        //console.log('total files:'+this.totalFiles())
                        if (this.totalFiles() > 0) {
                            this.showDialog3('提示', '')
                        } else {
                            this.removeNode(this.root, this.node, this.nodeData)
                        }
                    }
                    break;
                case '4':
                    console.log('selecter')

                     this.showDialog4('提示', this.node.node.title)

                    // this.treeSelectModal = true
                    // this.$refs.treeSelecter.show(this.rawData)
                    break;
                default:
                    console.log('nomatch')
            }
        },
        aclick(e) {
            console.log('aclick==>')
            e.stopPropagation()
        },
        showDialog4(title, foldername) {
            let that = this
            this.$Modal.confirm({
                title: title,
                render: h => {
                    return h('span', [
                        ' ',
                        h('span', {
                            domProps: {
                                innerHTML: `<span style="font-weight:bold;color:red;font-size:14px;" >` + foldername + `</span> 下包含子文件夹，是否移动？`,
                            }
                        }), '  ?'
                    ])
                },
                okText: '是',
                cancelText: '否',
                onOk: () => {
                    //this.removeNode(this.root, this.node, this.nodeData)
                    this.treeSelectModal = true
                    this.$refs.treeSelecter.show(this.rawData)
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },
        showDialog2(title, foldername) {
            let that = this
            this.$Modal.confirm({
                title: title,
                render: h => {
                    return h('span', [
                        ' ',
                        h('span', {
                            domProps: {
                                innerHTML: `<span style="font-weight:bold;color:red;font-size:14px;" >` + foldername + `</span> 下包含子文件夹，是否一并删除？`,
                            }
                        }), '  ?'
                    ])
                },
                okText: '是',
                cancelText: '否',
                onOk: () => {
                    this.removeNode(this.root, this.node, this.nodeData)
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },
        showDialog3(title, foldername) {
            let that = this
            this.$Modal.confirm({
                title: title,
                render: h => {
                    return h('span', [
                        ' ',
                        h('span', {
                            domProps: {
                                innerHTML: `文件夹下存在已上传文件，是否一并删除？`,
                            }
                        }), '  ?'
                    ])
                },
                okText: '是',
                cancelText: '否',
                onOk: () => {
                    this.removeNode(this.root, this.node, this.nodeData)
                },
                onCancel: () => {
                    return
                    // this.$Message.info('Clicked cancel');
                }
            });
        },
    }
}
</script>
<style lang="less" scoped>
</style>